import { Inline, Stack } from '@atlaskit/primitives';
import Spinner from '@atlaskit/spinner';
import { H4 } from '@atlassian/mpac-primitives';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const TWO_CLICK_APP_INSTALL_LOADING_TEST_ID = 'two-click-app-install-loading';
export const TwoClickAppInstallLoading = () => {
  return /*#__PURE__*/_jsxs(Stack, {
    space: "space.800",
    children: [/*#__PURE__*/_jsx(H4, {
      children: "Loading..."
    }), /*#__PURE__*/_jsx(Inline, {
      alignBlock: "center",
      alignInline: "center",
      children: /*#__PURE__*/_jsx(Spinner, {
        size: "small",
        testId: TWO_CLICK_APP_INSTALL_LOADING_TEST_ID
      })
    })]
  });
};